import type { AccountBillingSettingsDto, UpdateAccountBillingSettingsDto } from '@paladin-monorepo/common';
import API from '../api';

export const billingSettingsApi = {
  async getByAccountId(accountId: string): Promise<AccountBillingSettingsDto> {
    return API.get<AccountBillingSettingsDto>(
      `/accounts/${encodeURIComponent(accountId)}/billing-settings`,
    ).then((r) => r.data);
  },

  async update(
    accountId: string,
    dto: UpdateAccountBillingSettingsDto,
  ): Promise<AccountBillingSettingsDto> {
    return API.put<AccountBillingSettingsDto>(
      `/accounts/${encodeURIComponent(accountId)}/billing-settings`,
      dto,
    ).then((r) => r.data);
  },
};
